import { render, staticRenderFns } from "./videoTest.vue?vue&type=template&id=c39d6da0&scoped=true"
import script from "./videoTest.vue?vue&type=script&lang=js"
export * from "./videoTest.vue?vue&type=script&lang=js"
import style0 from "./videoTest.vue?vue&type=style&index=0&id=c39d6da0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39d6da0",
  null
  
)

export default component.exports